export default "__VITE_ASSET__534ff342__"